/* Honor theme JS: scroll reveal, mobile menu, cart count sync */
(function () {
  // Scroll reveal
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.reveal, .reveal-stagger');
  if (prefersReduced) {
    els.forEach(function (e) { e.classList.add('in'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (e) { e.classList.add('in'); });
  }

  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  // Cart count sync after AJAX cart changes (sections rendering or fetch)
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', !count);
    });
  });

  // Predictive search overlay (task 1.10)
  var overlay = document.querySelector('[data-search-overlay]');
  if (overlay) {
    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var searchOpener = null;
    var debounceTimer = null;

    var openSearch = function () {
      searchOpener = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    };
    var closeSearch = function () {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('inert', '');
      document.body.style.overflow = '';
      if (searchOpener && searchOpener.focus) searchOpener.focus();
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
      if (e.target.closest && e.target.closest('[data-search-close]')) closeSearch();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });

    var renderResults = function (data, q) {
      results.innerHTML = '';
      var products = (((data || {}).resources || {}).results || {}).products || [];
      var pages = (((data || {}).resources || {}).results || {}).pages || [];
      if (!products.length && !pages.length) {
        var none = document.createElement('p');
        none.className = 'search-overlay-empty';
        none.textContent = 'No matches for “' + q + '” — but we print more than the catalog shows. Try “banner” or request a quote.';
        results.appendChild(none);
        return;
      }
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'search-result';
        a.href = p.url;
        var img = document.createElement('img');
        img.className = 'search-result-img';
        img.alt = '';
        img.width = 44; img.height = 44;
        if (p.featured_image && p.featured_image.url) img.src = p.featured_image.url;
        else if (p.image) img.src = p.image;
        a.appendChild(img);
        var box = document.createElement('div');
        var t = document.createElement('div');
        t.className = 'search-result-title';
        t.textContent = p.title;
        box.appendChild(t);
        // Price line mirrors snippets/price-display: $0 or tagged contact-for-pricing → "Contact us for pricing";
        // tagged calculator-priced → "Price it instantly"; otherwise "From $X".
        var tags = p.tags || [];
        var num = parseFloat(p.price_max || p.price);
        var m = document.createElement('div');
        m.className = 'search-result-meta';
        if (isNaN(num) || num === 0 || tags.indexOf('contact-for-pricing') > -1) {
          m.textContent = 'Contact us for pricing';
        } else if (tags.indexOf('calculator-priced') > -1) {
          m.textContent = 'Price it instantly';
        } else {
          var min = parseFloat(p.price_min || p.price);
          m.textContent = 'From $' + (min % 1 === 0 ? min.toFixed(0) : min.toFixed(2));
        }
        box.appendChild(m);
        a.appendChild(box);
        results.appendChild(a);
      });
      pages.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'search-result search-result-page';
        a.href = p.url;
        var badge = document.createElement('span');
        badge.className = 'search-result-img';
        badge.textContent = 'Page';
        a.appendChild(badge);
        var t = document.createElement('div');
        t.className = 'search-result-title';
        t.textContent = p.title;
        a.appendChild(t);
        results.appendChild(a);
      });
      var all = document.createElement('a');
      all.className = 'search-overlay-all link-under';
      all.href = '/search?q=' + encodeURIComponent(q);
      all.textContent = 'See all results for “' + q + '” →';
      results.appendChild(all);
    };

    if (input && results) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        debounceTimer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page&resources[limit]=6&resources[options][unavailable_products]=last')
            .then(function (r) { return r.json(); })
            .then(function (data) { renderResults(data, q); })
            .catch(function () { /* quiet */ });
        }, 220);
      });
    }
  }

  // GA4: phone + email taps (event map, task 0.4). No-ops when gtag is absent.
  document.addEventListener('click', function (e) {
    if (typeof gtag !== 'function' || !e.target.closest) return;
    var a = e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!a) return;
    var isPhone = a.getAttribute('href').indexOf('tel:') === 0;
    gtag('event', isPhone ? 'phone_click' : 'email_click', { location: window.location.pathname });
  });
})();